import { IShipmentOfferState } from 'types/FMSGraphqlTypes'
import { IOfferFragment } from '../graphql/OfferFragment'

interface IIsReOfferEligibleProps extends Pick<IOfferFragment, 'offeredState'> {}

export const isReOfferEligible = ({ offeredState }: IIsReOfferEligibleProps) => {
  return offeredState === IShipmentOfferState.DedicatedRateOfferedToMoreCarriers
}
